import { ArrowPathIcon, ChevronLeftIcon, HomeIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import useLoading from "../../../hooks/useLoading";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { getUserDetails, getUserOrgTree, getUserResetDevice, updateUserDetail } from "../../../services/ api_services";
import ResetPasswordDialog from "../../../components/dialogs/ResetPasswordDialog";
import AccountSecurityDialog from "../../../components/dialogs/AccountSecurityDialog";
import { LockIcon, LockOpenIcon } from "../../../components/icons/LockIcons";
import SelectMenu from "../../../components/SelectMenu";
import useToast from "../../../hooks/useToast";
import { ToastTypes } from "../../../context/ToastProvider";
import SearchReferrerDialog from "../../../components/dialogs/SearchReferrerDialog";
import SearchOrgDialog from "../../../components/dialogs/SearchOrgDialog";
import { ROLES } from "../../../core/constants";
import { ACCOUNT_LOCK_STATUS, getAccountLockLevel } from "../../../core/Util";
import useUnlockUser from "../../../hooks/useUnlockUser";

const pages = [
    { name: "회원 관리", href: "/ad/user", current: false },
    { name: "상세보기", href: "", current: true },
];

const genders = [
    { name: "남", id: "M" },
    { name: "여", id: "F" },
];
const checkOptions = [
    { name: "사용", id: "0001" },
    { name: "탈퇴", id: "0002" },
    { name: "신규가입", id: "0003" },
];

export default function UserInfo() {
    const dbConfig = localStorage.getItem('X-DB-KEY');
    const isUrinalysis = () => dbConfig && !isEmpty(dbConfig) && dbConfig === 'urinalysis';

    const adminLevelCd = sessionStorage.getItem("adminLevelCd");

    const userDetail = {
        user_seq: "",
        user_hp_no: "", //핸드폰 번호
        user_pw: "", //비번
        user_email: "", //이메일
        user_height: "", //키
        user_sex: "", //성별
        user_type: "", //사용여부
        coupon_no: "", //회원권
        user_nm: "", //이름
        user_bir: "", //생일
        user_weight: "", //몸무게
        user_coupon_start: "", //사용기간
        user_coupon_end: "", //사용기간
        device_model: "", //디바이스 정보
        org_id: null,
        org_full_path: "",  // 회원구분(조직)
        referrer_user_nm: "",   // 추천인 이름
        referrer_user_seq: "",    // 추천인 seq
        login_fail_count: 0,           // 로그인 실패 누적 횟수 (urinalysis 전용, oxygen은 null)
        login_locked_until: null,      // 임시 잠금 해제 시각
        login_permanently_locked: false, // 영구 잠금 여부
    };

    const { showToast } = useToast();
    const { userSeq } = useParams();
    const requestUnlock = useUnlockUser();

    const [selectedGender, setSelectedGender] = useState(genders[0]);
    const [checked, setChecked] = useState(checkOptions[0]);
    const [cond, setCond] = useState(userDetail);
    const { loading, setLoading } = useLoading();
    const [showResetPassDialog, setShowResetPassDialog] = useState(false);
    const [showAccountSecurityDialog, setShowAccountSecurityDialog] = useState(false);

    const location = useLocation();

    const [showPopup, setShowPopup] = useState(false);
    const [showOrgPopup, setShowOrgPopup] = useState(false);
    const [orgTree, setOrgTree] = useState([]);

    useEffect(() => {
        if (location.state?.products && location.state.products.length > 0) {
            setOrgTree(location.state.products);
        } else {
            selectUserOrgTree();
        }
    }, [location.state]);

    //회원구분(조직) 목록 조회 API (목록 화면에서 넘어온 값이 없을 때, 예: 새로고침/직접 진입)
    const selectUserOrgTree = async () => {
        try {
            const adminOrgId = sessionStorage.getItem("adminOrgId");
            const response = await getUserOrgTree({ org_id: adminOrgId, use_yn: "0001" });
            const formattedOptions = [
                { name: "선택", id: null },
                ...response.data.map((item) => ({
                    name: item.full_path,
                    id: item.org_id.toString(),
                    total_coupon: item.total_coupon,
                    issued_coupon: item.issued_coupon,
                    referrer_count: item.referrer_count,
                })),
            ];
            setOrgTree(formattedOptions);
        } catch (e) {
            console.log("e===>", e);
        }
    };

    useEffect(() => {
        selectUserDetail();
    }, []);

    //상세정보 조회 API
    const selectUserDetail = async () => {
        setLoading(true);
        try {
            const response = await getUserDetails(userSeq);
            // const response = await nonAuthInstance.get("/user/select/detail/list/" + userSeq);
            console.log("🚀 ~ selectUserDetail ~ response:", response);
            if (response || !response) {
                setLoading(false);
            }
            if (response && response.status === 200 && !isEmpty(response.data)) {
                // console.log("🚀 ~ selectUserDetail ~ response.data:", response.data);
                setCond(response.data);
                const gender = response.data.user_sex;
                setSelectedGender(genders.find((item) => item.id === gender));

                console.log("🚀 ~ selectUserDetail ~ response.data:", response.data);
                setChecked(checkOptions.find((item) => item.id === response.data.user_type));

            } else {
                setCond(userDetail);
            }
        } catch (e) {
            console.log("e===>", e);
            setLoading(false);
        }
    };

    function onResetDevice() {
        
        ResetDevice();
    }

    const ResetDevice = async() => {
        
        const response = await getUserResetDevice(cond.user_seq);
        console.log('response:::', response);
        if (response.data.status === "OK") {
            console.log(cond);
            alert(cond.user_nm + '님의 디바이스 정보가 초기화 되었습니다.');
            setCond((preVal) => {
                return {
                    ...preVal,
                    user_device_id: null,
                };
            });
        }
    }

    //상세정보 수정 API
    const updateUserInfo = async (condTmp) => {
        setLoading(true);
        console.log("[updateUserInfo][cond] ==> ", condTmp);
        try {
            const response = await updateUserDetail(condTmp);
            console.log("🚀 ~ updateUserDetail ~ response:", response);
            setLoading(false);
            if (response && response.status === 200) {
                showToast(ToastTypes.SUCCESS, "성공", "회원 정보 수정을 완료했습니다.");
                await selectUserDetail();
            }
        } catch (e) {
            console.log("e===>", e);
            setLoading(false);
        }
    };

    function handleOnClickUpdate() {
        if (
            isEmpty(cond.user_hp_no) ||
            isEmpty(cond.user_nm) ||
            isEmpty(cond.user_coupon_start) ||
            isEmpty(cond.user_coupon_end) ||
            isEmpty(cond.user_type)
        ) {
            showToast(ToastTypes.WARNING, "안내", "필수 항목을 입력해 주세요.");
            return;
        }

        let condTmp = {
            user_seq: cond.user_seq,
            user_hp_no: cond.user_hp_no,
            user_email: cond.user_email,
            user_height: cond.user_height,
            user_sex: cond.user_sex,
            user_type: cond.user_type,
            user_nm: cond.user_nm,
            user_bir: cond.user_bir,
            user_weight: cond.user_weight,
            user_coupon_start: cond.user_coupon_start,
            user_coupon_end: cond.user_coupon_end,
            device_model: cond.device_model,
            referrer_user_seq: cond.referrer_user_seq,
            org_id: cond.org_id,
        };

        // 탈퇴로 변경후 수정했을 때
        if (checked === checkOptions[1]) {
            const isConfirmed = window.confirm("탈퇴 수정 시 개인 정보 및 모든 정보가 삭제됩니다. \n한번 삭제된 데이터는 다시 되돌릴 수 없습니다.\n정말 탈퇴 처리 하시겠습니까?");
            if (isConfirmed) {
                var today = new Date();
                var year = today.getFullYear();
                var month = ('0' + (today.getMonth() + 1)).slice(-2);
                var day = ('0' + today.getDate()).slice(-2);
                var dateString = year + '-' + month  + '-' + day;

                condTmp.user_hp_no = '01000000000';
                condTmp.user_nm = '탈퇴 '+dateString;
                condTmp.user_bir = null;
                condTmp.user_email = null;
                condTmp.user_height = null;
                condTmp.user_weight = null;
                condTmp.user_coupon_start = null;
                condTmp.user_coupon_end = null;
                condTmp.user_sex = null;
            }else {
                return;
            }
        }

        updateUserInfo(condTmp);
    }

    const lockLevel = getAccountLockLevel(cond);
    const lockStatus = ACCOUNT_LOCK_STATUS[lockLevel];

    //잠금 해제 성공 시 화면의 잠금 상태를 즉시 반영
    const clearLockState = () => {
        setCond((preVal) => ({
            ...preVal,
            login_fail_count: 0,
            login_locked_until: null,
            login_permanently_locked: false,
        }));
    };

    const handleOnClickUnlock = async () => {
        const success = await requestUnlock(cond.user_seq);
        if (success) {
            clearLockState();
        }
    };

    return (
        <div>
            <nav className="flex border-b border-gray-200 bg-white -mx-8 -mt-6 max-w-full" aria-label="Breadcrumb">
                <ol className=" flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
                    <li className="flex">
                        <div className="flex items-center">
                            <a href="/" className="text-gray-400 hover:text-gray-500">
                                <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                                <span className="sr-only">Home</span>
                            </a>
                        </div>
                    </li>
                    {pages.map((page) => (
                        <li key={page.name} className="flex">
                            <div className="flex items-center">
                                <svg
                                    className="h-full w-6 flex-shrink-0 text-gray-200"
                                    viewBox="0 0 24 44"
                                    preserveAspectRatio="none"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <Link
                                    to={page.href}
                                    className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                    aria-current={page.current ? "page" : undefined}
                                >
                                    {page.name}
                                </Link>
                            </div>
                        </li>
                    ))}
                </ol>
            </nav>
            <ResetPasswordDialog userSeq={cond.user_seq} isOpen={showResetPassDialog} onClose={() => setShowResetPassDialog(false)} />
            <AccountSecurityDialog
                userSeq={cond.user_seq}
                isOpen={showAccountSecurityDialog}
                onClose={() => setShowAccountSecurityDialog(false)}
                loginLockedUntil={cond.login_locked_until}
                loginPermanentlyLocked={cond.login_permanently_locked}
                onUnlockSuccess={() => clearLockState()}
            />
            <div className="isolate bg-white px-6 py-24 sm:py-10 lg:px-8 max-w-full">
                <button
                    type="button"
                    className="inline-flex items-center justify-center gap-x-1 rounded bg-white px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50"
                    onClick={() => window.history.back()}
                >
                    <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" />
                    뒤로 가기
                </button>
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-2xl">상세보기</h2>
                </div>
                <div className="mx-auto max-w-3xl sm:mt-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                        {isUrinalysis() && (
                            <div className="sm:col-span-2 flex items-center justify-between rounded-lg bg-gray-50 px-4 py-3">
                                <div className="flex items-center gap-x-2.5">
                                    <span className="text-sm font-semibold text-gray-900">계정 상태</span>
                                    <span
                                        className="inline-flex items-center gap-x-1.5 rounded-full px-2.5 py-1 text-xs font-medium"
                                        style={{ background: lockStatus.bg, border: `1px solid ${lockStatus.border}`, color: lockStatus.ink }}
                                    >
                                        {lockLevel === "normal" ? (
                                            <LockOpenIcon className="h-3.5 w-3.5" />
                                        ) : (
                                            <LockIcon className="h-3.5 w-3.5" />
                                        )}
                                        {lockStatus.label}
                                    </span>
                                </div>
                                {adminLevelCd === ROLES.Admin && (
                                    <div className="flex items-center gap-x-3">
                                        <button
                                            type="button"
                                            className="text-sm font-semibold text-blue-600 hover:text-blue-500"
                                            onClick={() => setShowAccountSecurityDialog(true)}
                                        >
                                            상태 및 로그 보기
                                        </button>
                                        {lockLevel !== "normal" && (
                                            <button
                                                type="button"
                                                className="inline-flex items-center rounded bg-blue-600 px-2.5 py-1 text-xs font-semibold text-white shadow-sm hover:bg-blue-500"
                                                onClick={() => handleOnClickUnlock()}
                                            >
                                                잠금 해제
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        <div>
                            <div className="inline-flex">
                                <label htmlFor="userId" className="block text-sm font-semibold leading-6 text-gray-900">
                                    아이디 (휴대전화번호)
                                </label>
                                <label className="ml-1 text-red-700 font-bold">*</label>
                            </div>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    name="userId"
                                    id="userId"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.user_hp_no && cond.user_hp_no) || ""}
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_hp_no: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        <div>
                            <div className="inline-flex mb-1">
                                <label htmlFor="memberCode" className="block text-sm font-semibold leading-6 text-gray-900">
                                    추천인
                                </label>
                                <label className="ml-1 text-red-700 font-bold">*</label>
                            </div>
                            
                            <div className="flex gap-2">
                                <div className="flex-1">
                                    <input
                                        type="text"
                                        name="memberCode"
                                        id="memberCode"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-400 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                        value={(cond.referrer_user_nm && cond.referrer_user_nm) || ""}
                                        disabled
                                        readOnly
                                    />
                                </div>
                                <button 

                                    onClick={() => setShowPopup(true)}
                                    className="rounded-md bg-gray-200 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300"
                                >
                                    조회
                                </button>

                                {showPopup && (
                                    <SearchReferrerDialog
                                        onClose={() => setShowPopup(false)}
                                        onSelect={(item) => {
                                            setCond((preVal) => {
                                                return {
                                                    ...preVal,
                                                    referrer_user_nm: item.user_nm,
                                                    referrer_user_seq: item.user_seq,
                                                }
                                            });
                                        }}
                                        orgTree={orgTree}
                                    />
                                )}

                            </div>
                        </div>
                        
                        <div>
                            <div className="inline-flex">
                                <label htmlFor="password" className="block text-sm font-semibold leading-6 text-gray-900">
                                    비밀번호
                                </label>
                                <label className="ml-1 text-red-700 font-bold">*</label>
                            </div>
                            <div className="mt-2">
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-400 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.user_pw && cond.user_pw) || ""}
                                    disabled
                                    readOnly
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userNm" className="block text-sm font-semibold leading-6 text-gray-900">
                                이름
                            </label>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    name="userNm"
                                    id="userNm"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={cond.user_nm && cond.user_nm}
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_nm: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userMail" className="block text-sm font-semibold leading-6 text-gray-900">
                                이메일
                            </label>
                            <div className="mt-2">
                                <input
                                    type="email"
                                    name="userMail"
                                    id="userMail"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.user_email && cond.user_email) || ""}
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_email: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-semibold leading-6 text-gray-900">생년월일</label>
                            <div className="mt-2">
                                <input
                                    type="date"
                                    name="birthDate"
                                    id="birthDate"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.user_bir && cond.user_bir) || ""}
                                    onChange={(e) => {
                                        console.log("bir==>", e.target.value);
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_bir: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userStature" className="block text-sm font-semibold leading-6 text-gray-900">
                                키 <span>&#40;</span>cm
                                <span>&#41;</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    type="number"
                                    name="userStature"
                                    id="userStature"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.user_height && cond.user_height) || ""}
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_height: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userWeight" className="block text-sm font-semibold leading-6 text-gray-900">
                                몸무게 <span>&#40;</span>kg
                                <span>&#41;</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    type="number"
                                    name="userWeight"
                                    id="userWeight"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.user_weight && cond.user_weight) || ""}
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_weight: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <SelectMenu
                                required
                                labelText={"성별"}
                                options={genders}
                                onSelect={(e) => {
                                    console.log("🚀 ~ UserInfo ~ e.value:", e.id);
                                    setCond((preVal) => {
                                        return {
                                            ...preVal,
                                            user_sex: e.id,
                                        };
                                    });
                                    setSelectedGender(genders.find((item) => item.id === e.id));
                                }}
                                selectedId={cond.user_sex}
                            />
                        </div>
                        <div>
                            <div className="inline-flex">
                                <label htmlFor="memberDate" className="block text-sm font-semibold leading-6 text-gray-900">
                                    사용기간
                                </label>
                                <label className="ml-1 text-red-700 font-bold">*</label>
                            </div>
                            <div className="flex justify-between mt-2">
                                <input
                                    type="date"
                                    name="memberDate"
                                    id="memberDate"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.user_coupon_start && cond.user_coupon_start) || ""}
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_coupon_start: e.target.value,
                                            };
                                        });
                                    }}
                                    readOnly={adminLevelCd !== ROLES.Admin && adminLevelCd !== ROLES.Volunteer}
                                />
                                <div className="mx-1 my-1">
                                    <span> ~ </span>
                                </div>
                                <input
                                    type="date"
                                    name="memberDate"
                                    id="memberDate"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.user_coupon_end && cond.user_coupon_end) || ""}
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_coupon_end: e.target.value,
                                            };
                                        });
                                    }}
                                    readOnly={adminLevelCd !== ROLES.Admin && adminLevelCd !== ROLES.Volunteer}
                                />
                            </div>
                        </div>

                        <div>
                            <SelectMenu
                                labelText={"사용여부"}
                                required
                                options={checkOptions}
                                onSelect={(e) => {
                                    console.log("🚀 ~ UserInfo ~ e:", e);
                                    setCond((preVal) => {
                                        return {
                                            ...preVal,
                                            user_type: e.id,
                                        };
                                    });

                                    if (e.id === "0001") {
                                        setChecked(checkOptions[0]);
                                    } else if (e.id === "0002") {
                                        setChecked(checkOptions[1]);
                                    }
                                }}
                                selectedId={cond.user_type}
                            />
                        </div>
                        <div>
                            <label htmlFor="phoneInfo" className="block text-sm font-semibold leading-6 text-gray-900">
                                폰 디바이스 정보
                            </label>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    name="phoneInfo"
                                    id="phoneInfo"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    value={(cond.device_model && cond.device_model) || ""}
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                device_model: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-span-2">
                            <label className="block text-sm font-semibold leading-6 text-gray-900 mb-1">
                                회원구분(조직)
                            </label>
                            <div className="flex gap-2">
                                <div className="flex-1">
                                <SelectMenu
                                    options={orgTree}
                                    onSelect={(e) => {
                                        console.log("🚀 ~ UserInfo ~ e:", e);
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                org_id: e.id
                                            };
                                        });
                                    }}
                                    // null-safe
                                    selectedId={cond.org_id?.toString() ?? null}
                                />
                                </div>
                                <button
                                    onClick={() => setShowOrgPopup(true)}
                                    className="rounded-md bg-gray-200 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300 whitespace-nowrap"
                                >
                                조회
                                </button>
                                {showOrgPopup && (
                                    <SearchOrgDialog
                                    onClose={() => setShowOrgPopup(false)}
                                    onSelect={(item) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                org_id: item.id,
                                            }
                                        });
                                    }}
                                    OrgTree={orgTree}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="mt-10 flex justify-between">
                        <button
                            type="submit"
                            className="inline-flex items-center gap-x-1.5 rounded bg-red-500 px-3 py-2 text-sm font-semibold text-white hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                            onClick={() => {
                                setShowResetPassDialog(true);
                            }}
                        >
                            <ArrowPathIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                            비밀번호 초기화
                        </button>
                        <button
                            type="submit"
                            className="inline-flex items-center gap-x-1.5 rounded bg-pink-500 px-3 py-2 text-sm font-semibold text-white hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                            onClick={() => {
                                onResetDevice();
                            }}
                        >
                            <ArrowPathIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                            디바이스정보 초기화
                        </button>
                        <div className="flex">
                            <button
                                type="submit"
                                className="inline-flex items-center gap-x-1.5 rounded bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                onClick={() => handleOnClickUpdate()}
                            >
                                <CheckCircleIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                수정
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
